export const DIVISIONS = [
  {
    slug: "healthcare",
    name: "Healthcare",
    tagline: "Compassionate care, modern medicine.",
    summary:
      "A network of multi-specialty hospitals, diagnostic centers and wellness clinics delivering world-class patient outcomes across the Indo-Pacific region.",
    image: "https://images.unsplash.com/photo-1512678080530-7760d81faba6",
    services: [
      "Multi-specialty Hospitals",
      "Diagnostic Imaging",
      "Preventive Health Checks",
      "Telemedicine Consultations",
      "Home Care Services",
      "Medical Tourism",
      "Nursing Home Care Services (12/24 hrs)",
      "Escort Services for Hospitals, Dialysis & Medical Treatment",
    ],
    stats: [
      { k: "Hospitals", v: "12+" },
      { k: "Specialists", v: "400+" },
      { k: "Patients / yr", v: "1.2M" },
    ],
    iconName: "Stethoscope",
  },
  {
    slug: "automobile",
    name: "Automobile",
    tagline: "Mobility engineered for tomorrow.",
    summary:
      "Premium dealerships, service centers and fleet solutions — bringing leading global brands and EV technology to discerning customers.",
    image: "https://images.pexels.com/photos/30662798/pexels-photo-30662798.jpeg",
    services: [
      "Premium Dealerships",
      "Certified Pre-Owned",
      "EV Charging Network",
      "Fleet & Leasing",
      "Service & Maintenance",
    ],
    stats: [
      { k: "Showrooms", v: "28" },
      { k: "Brands", v: "15" },
      { k: "Cars Sold", v: "60K+" },
    ],
    iconName: "Car",
  },
  {
    slug: "real-estate",
    name: "Real Estate",
    tagline: "Building landmarks, creating value.",
    summary:
      "Developing iconic residential, commercial and mixed-use projects — designed with sustainability and long-term value at the core.",
    image: "https://images.unsplash.com/photo-1707077865701-2854996afc4f",
    featuredListings: [
      {
        id: "exquisite-263",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/pwo5h9wr_real%20estate.jpeg",
        title: "Exquisite 263 Sq. Yd. Floor",
        location: "Sector 45",
        price: "₹3.30 Cr*",
        phone: "9999099459",
        tag: "Ultra Luxury Floor",
        highlights: [
          "Ready to Move In",
          "Sprawling Layout & Premium Finishes",
          "Serene Locality of Sector 45",
          "Exclusivity & Privacy",
          "Minutes from Hospitals, Metro & Markets",
        ],
      },
      {
        id: "hermitage-centralis-ready",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/r0um8bxg_1.jpeg",
        title: "Hermitage Centralis — Ready to Move In",
        location: "Zirakpur",
        price: "On Request",
        phone: "9354859598",
        tag: "3, 3+1 & 4 BHK",
        highlights: [
          "Premium Residencies & Penthouses",
          "Crafted for Better Living",
          "Sanctuary of Tranquil Living",
          "Ready to Move In Homes",
        ],
      },
      {
        id: "hermitage-centralis-lifestyle",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/12bdf8mq_2.jpeg",
        title: "Hermitage Centralis — Lifestyle, Not Promises",
        location: "VIP Road, Zirakpur",
        price: "On Request",
        phone: "9354859598",
        tag: "200+ Families Living",
        highlights: [
          "Ready Homes. Real Amenities. Real Living.",
          "200+ Families already living",
          "3, 3+1 & 4 BHK Premium Residencies",
          "Prime VIP Road location",
        ],
      },
      {
        id: "hermitage-royale-fitness",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/as9aadvd_3.jpeg",
        title: "Hermitage Royale — Crafted for the Elite",
        location: "VIP Junction, Zirakpur-Patiala Highway",
        price: "On Request",
        phone: "9354859598",
        tag: "3 BHK Premium",
        highlights: [
          "Modern Fitness Space",
          "Mindful Workouts & Lasting Wellness",
          "Crafted for the Elite",
          "Prime highway connectivity",
        ],
      },
      {
        id: "hermitage-royale-furnished",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/rtg69xz0_4.jpeg",
        title: "Hermitage Royale — Fully Furnished Sample Flat",
        location: "VIP Junction, Zirakpur-Patiala Highway",
        price: "On Request",
        phone: "9354859598",
        tag: "3 BHK Premium · Fully Furnished",
        highlights: [
          "What You See Is What You Get",
          "Step into a ready sample flat",
          "Range of bed designs to choose from",
          "Fully furnished, move-in ready",
        ],
      },
      {
        id: "hermitage-centralis-breathe",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/ru7kcs2a_5.jpeg",
        title: "Hermitage Centralis — Homes That Breathe With You",
        location: "VIP Road, Zirakpur",
        price: "On Request",
        phone: "9354859598",
        tag: "Ready to Move · 200+ Families",
        highlights: [
          "Ready to Move In",
          "200+ Families already living",
          "3, 3+1 & 4 BHK Premium Residencies",
          "Penthouse options available",
        ],
      },
      {
        id: "hermitage-centralis-drives",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/zysaa8qc_6.jpeg",
        title: "Hermitage Centralis — Big Dreams, Short Drives",
        location: "VIP Road, Zirakpur",
        price: "On Request",
        phone: "9354859598",
        tag: "Prime Connectivity",
        highlights: [
          "Major IT & Corporate Hubs within 20 mins (avg.)",
          "3, 3+1 & 4 BHK Premium Residencies",
          "Penthouses available",
          "Effortless daily commute",
        ],
      },
      {
        id: "hermitage-centralis-schools",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/1269j3eq_7.jpeg",
        title: "Hermitage Centralis — A Home for Growing Families",
        location: "VIP Road, Zirakpur",
        price: "On Request",
        phone: "9354859598",
        tag: "Family-Friendly Locale",
        highlights: [
          "Top Schools within 10 mins (avg.)",
          "Safe, walkable community",
          "3, 3+1 & 4 BHK Premium Residencies",
          "Ideal for growing families",
        ],
      },
      {
        id: "garden-of-eden-goa",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/g4074l2m_9.jpeg",
        title: "Yugen Garden of Eden — Waterfront Studios",
        location: "Prime North of Goa",
        price: "Starting ₹65 Lac*",
        phone: "9354859598",
        tag: "Studio · 1BHK · 2BHK",
        highlights: [
          "Luxury Studio Apartments",
          "5-Star Hospitality Living",
          "Waterfront Experiences",
          "Future-Ready Investment",
        ],
      },
      {
        id: "garden-of-eden-home-loan",
        flyer: "https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/nin9balc_8.jpeg",
        title: "Garden of Eden — Home Loan Partner",
        location: "Available across all Garden of Eden bookings",
        price: "Easy Financing",
        phone: "9354859598",
        tag: "Financing Partner",
        highlights: [
          "Easy Financing, Secure Investment",
          "Trusted home loan partner",
          "Quick approvals for eligible buyers",
          "RERA No. PP1310002501906",
        ],
      },
    ],
    services: [
      "Luxury Residences",
      "Commercial Towers",
      "Mixed-Use Developments",
      "Property Management",
      "Investment Advisory",
    ],
    stats: [
      { k: "Projects", v: "45+" },
      { k: "Sq.ft. Built", v: "32M" },
      { k: "Cities", v: "9" },
    ],
    iconName: "Building2",
  },
  {
    slug: "ipg-sales",
    name: "IPG Sales Pvt. Ltd.",
    tagline: "Distribution that drives growth.",
    summary:
      "Our B2B and retail distribution arm — channel partnerships, key-account servicing and trade marketing across multiple categories and geographies.",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80",
    services: [
      "Channel Distribution",
      "Key Account Management",
      "Retail Operations",
      "Trade Marketing",
      "Sales Analytics",
    ],
    stats: [
      { k: "Partners", v: "600+" },
      { k: "SKUs", v: "2,400" },
      { k: "Markets", v: "11" },
    ],
    iconName: "Briefcase",
  },
  {
    slug: "legal",
    name: "Legal Consultant & Advocate",
    tagline: "Trusted counsel. Decisive advocacy.",
    summary:
      "A full-service legal practice covering corporate, commercial, regulatory and dispute resolution mandates — led by senior counsel and seasoned trial advocates.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&q=80",
    services: [
      "Corporate & Commercial Law",
      "Litigation & Dispute Resolution",
      "M&A and Transactional Advisory",
      "Intellectual Property",
      "Compliance & Governance",
    ],
    stats: [
      { k: "Cases Handled", v: "1,800+" },
      { k: "Senior Counsels", v: "24" },
      { k: "Years of Practice", v: "20+" },
    ],
    iconName: "Scale",
  },
];

export const getDivision = (slug) => DIVISIONS.find((d) => d.slug === slug);
